export default "<app-header *ngIf=\"!hideHeader\"></app-header>\n<router-outlet></router-outlet>\n<app-footer></app-footer>";